export default __webpack_public_path__ + "static/media/icon-templates-dark.e0a74a8a.svg";